import { Component } from 'preact'
import prerendered from '../hoc/prerendered-content'
import s from './faq.sass'
import gs from './generic-page.sass'
import Footer from '../components/footer'
import { TitleAndTextSlice } from '../components/slices/title-and-text'
import ReactIframeResizer from 'react-iframe-resizer-super'

const iframeResizerOptions = { checkOrigin: false }

export default prerendered(
  class extends Component {
    render ({ content }) {
      return (
        <div className={gs.view}>
          <div class={gs.header}>
            <div class={gs.inner}>
              <h1>{content.title}</h1>
            </div>
            { content.heroImage && (
              <img src={content.heroImage.src} alt={content.heroImage.alt || content.title} />
            ) }
          </div>

          <div className={s.inner}>
            {(content.textTitle || content.textDescription) && (
              <TitleAndTextSlice
                title={content.textTitle}
                text={content.textDescription}
              />
            )}
            <ReactIframeResizer
              iframeResizerOptions={iframeResizerOptions}
              src='https://stc.imbox.wiki/'
            />
          </div>

          <Footer />
        </div >
      )
    }
  }
)



// WEBPACK FOOTER //
// ./routes/faq.js